'use client';

import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

function ChatSidebarIcon({ isOpen }: { isOpen: boolean }) {
  return (
    <svg
      aria-hidden="true"
      className="size-4 max-md:-scale-x-100"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="stroke-current"
        height="11"
        rx="2"
        strokeWidth="1.5"
        width="12"
        x="2"
        y="2.5"
      />
      <path
        className={cn(
          'transition-colors',
          isOpen ? 'fill-current text-zinc-400' : 'stroke-current',
        )}
        d="M5.5 3.25V12.75"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      {isOpen ? (
        <rect
          className="fill-current text-zinc-400"
          height="8.5"
          rx="1"
          width="2.5"
          x="3"
          y="3.75"
        />
      ) : null}
    </svg>
  );
}

export function PrV2SidebarTopNavTrigger({ className }: { className?: string }) {
  const { isMobile, open, openMobile } = useSidebar();

  const isOpen = isMobile ? openMobile : open;
  const label = isOpen ? 'Collapse chat sidebar' : 'Expand chat sidebar';

  return (
    <SidebarTrigger
      aria-label={label}
      className={cn('size-8 text-zinc-500 hover:bg-zinc-900 hover:text-zinc-200', className)}
      icon={<ChatSidebarIcon isOpen={isOpen} />}
      title={label}
    />
  );
}
